<rid-flash-number
  (finished)="$router.navigate(['/mechanics/formule'])"
  [numbers]="[1, 2, 3, 4, 5, 9999, 12345, 123456, 1234567]"
  class="h-dvh"
/>
